// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3DLR9","inner":"Form_inner__2A0jI","range":"Form_range__unydL","name":"Form_name__1CXjA","actions":"Form_actions__15Ksi"};